<template>
    <common-dialog
      ref="dialog"
      title="Edit Goods"
      :inputs-map="form"
      :save-cb="saveGoods"
      :reset-inputs="reset"
    >
    </common-dialog>
  </template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// models
import { BolGoodsModifyForm } from '@/core/models/goods'

export default {
  name: 'BolGoodsEdit',
  props: {},
  components: {
    CommonDialog
  },
  methods: {
    saveGoods(info, done, error) {
      // todo 需要检查 输入的东西是否正确
      const arr = Object.values(info)
      this.saveCb(arr)
      this.$refs.dialog.close()
    },
    open(data, saveCb) {
      data.forEach((val, index) => {
        this.originalForm[index].value = val
        this.form[index].value = val
      })
      this.saveCb = saveCb
      this.$refs.dialog.open()
    },
    reset() {
      this.form = this.originalForm
    }
  },
  data() {
    return {
      form: cloneDeep(BolGoodsModifyForm),
      originalForm: cloneDeep(BolGoodsModifyForm),
      saveCb: null
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
